import ModalInvoiceCreate from './ModalInvoiceCreate';
import ModalInvoiceDelete from './ModalInvoiceDelete';
import ModalInvoiceFilter from './ModalInvoiceFilter';
import ModalInvoicePrint from './ModalInvoicePrint';
import ModalInvoiceUpdate from './ModalInvoiceUpdate';

export default Object.assign(
  {},
  {
    Create: ModalInvoiceCreate,
    Update: ModalInvoiceUpdate,
    Filter: ModalInvoiceFilter,
    Delete: ModalInvoiceDelete,
    Print: ModalInvoicePrint,
  },
);
